import React, { useEffect, useState } from 'react';
import Main from '../Main';
import { Box } from '@mui/material';
import DataTable from '../Table/DataTable';
import { sellersColumns } from '../Table/TableColumns';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import BackupTableIcon from '@mui/icons-material/BackupTable';
import AddSeller from './AddSeller';
import { useDispatch, useSelector } from 'react-redux';
import { getAllSeller } from '../../../Redux/SellerRedux';

function Seller() {
  const dispatch = useDispatch();
  const user = JSON.parse(localStorage.getItem('user'));
  const { allSeller, newSeller, statusUpdate } = useSelector(
    (state) => state.sellerRedux
  );
  const [showForm, setShowForm] = useState(
    localStorage.getItem('showForm') === 'true' ? true : false
  );
  const [viewMode, setViewMode] = useState(false);

  useEffect(() => {
    localStorage.setItem('showForm', 'false');
    dispatch(getAllSeller(user.userId));
    const isViewMode = localStorage.getItem('vM');
    if (isViewMode === 'true') {
      setViewMode(true);
    } else {
      setViewMode(false);
    }
  }, [dispatch, user.userId, showForm, newSeller, statusUpdate]);

  const handleButtonClick = () => {
    localStorage.setItem('vM', 'false');
    const newShowForm = !showForm;
    setShowForm(newShowForm);
    localStorage.setItem('showForm', newShowForm.toString());
  };

  const rows = Array.isArray(allSeller)
    ? allSeller.map((seller, index) => {
        return {
          id: seller._id,
          sNo: index + 1,
          firstName: seller.firstName,
          lastName: seller.lastName,
          displayName: seller.displayName,
          gender: seller.gender,
          emailId: seller.emailId,
          phoneNumber: seller.phoneNumber,
          isActive: seller.isActive === true ? 'Yes' : 'No',
        };
      })
    : [];
  return (
    <Main>
      <Box component='main' sx={{ flexGrow: 1, p: 3 }}>
        <div className='container border p-4'>
          <div className='row '>
            <div className='col-12 text-end'>
              {!showForm && (
                <button
                  type='button'
                  className='btn btn-success'
                  onClick={handleButtonClick}
                >
                  <AddCircleIcon style={{ marginRight: '5px' }} />
                  Add Seller
                </button>
              )}
              {showForm && !viewMode && (
                <button
                  type='button'
                  className='btn btn-success'
                  onClick={handleButtonClick}
                >
                  <BackupTableIcon style={{ marginRight: '5px' }} />
                  Show Table
                </button>
              )}
            </div>
          </div>
          {showForm ? (
            <AddSeller setShowForm={setShowForm} />
          ) : (
            <div className='row mt-3'>
              <div className='col-md-12'>
                <DataTable
                  rows={rows}
                  setShowForm={setShowForm}
                  columns={sellersColumns}
                  tableType='seller'
                />
              </div>
            </div>
          )}
        </div>
      </Box>
    </Main>
  );
}

export default Seller;
